import { __, compose, concat, curry, equals, last, not, when } from 'ramda'

/**
 * Factory for IRI strings.
 *
 * @param {String} basePath
 * @param {String|Number} id
 * @type {function}
 */
const iriFactory = curry((basePath, id) => compose(
  concat(__, String(id)),
  when(compose(not, equals('/'), last), concat(__, '/')),
)(basePath))

export default iriFactory
